import {
    MainImgIsNullAndPrivateGoodsNum,
    RepeatGoodsNum,
    MallItemRemoveParam,
    MallItemRemoveResult,
    UpdateDistributionParam,
    UpdateDistributionResult,
    DistributionSpuQueryParam,
    MyselfSpuVo,
    GoUserCategoryVo,
    DistributionGoodsListQueryVo1,
    DistributionSpuVo,
    SpuUserCategoryVo,
    UpdateSpuCategoryParam,
    OpenSpuListUsingGetParams,
    PostSpuVo,
    PostSpuQueryVo,
    QueryInviteSpuCountVo,
    InviteDisSpuCountVo,
    CreateParamVo,
    DisGoodsStatisticsVo,
    QueryMallSelectedSpuVo,
    GoodsMallSelectedSpuVo,
    GoSupplierConfig,
    AutoForSaleResultVo,
    SupplierForSaleNumVo,
    PromoteAutoResult,
    QueryTaskUsingGet3Params,
    RedisProgressInfo,
    BuyerSupplierGoodsQuery2,
    BrandMallGoodsVo,
    SupplierPromoteGoodsParam,
    SupplierPromoteChannelResult,
    PromoteGoodsItemParam,
    PromoteGoodsItemResult,
} from '@servicesTypings/goodsRequest'
import { ShopCountUsingGetParams, ShopStatisticsVO } from '@servicesTypings/companyRequest'
import {
    QueryVisitorInfoUsingGetParams,
    VisitorInfoVo,
    QueryVisitorCountUsingGetParams,
    VisitorCountVo,
    PlatformAndCategoryVo,
    GetVisitorTrendUsingGet1Params,
    VisitorTrendVo,
    CoConfig,
    SupplierCapacityVo,
    PartnerQuerySupplierCapacityUsingGetParams,
    GetSiteNoticeUsingGet1Params,
} from '@servicesTypings/drpRequest'
import { FindBindOfflineSupplierUsingGetParams, FindBindOfflineSupplierResult } from '@servicesTypings/towerDrpRequest'
import {
    companyRequest,
    goodsRequest,
    towerDrpRequest,
    drpRequest,
    openDrpRequest,
    goodsBasicRequest,
} from '@/utils/request'

// 分销小站，获取库存信息
/**
 * 查询款纬度的ERP相关字段信息-已弃用
 */
export function querySpuErpInfoList(data: string[]): API.Res<object[]> {
    return goodsRequest.post('/goodslist/erp/querySpuErpInfoList', { data })
}

// 分销小站，设置商品分销商可见-所有人可见，并设置对应的展架分类
/**
 * 分销商城，设置商品分销商可见/所有人可见，并设置对应的展架分类
 */
export function updateMallDistribution(data: UpdateDistributionParam): API.Res<UpdateDistributionResult> {
    return goodsRequest.post('/mall/goods/updateDistribution', { data })
}

// 分销小站添加供销商品列表
/**
 * 分销商城添加供销商品列表
 */
export function queryMallSpuList(data: DistributionSpuQueryParam): API.Res<MyselfSpuVo[]> {
    return goodsRequest.post('/mall/goods/spuList', { data })
}

export function getPromoteGoodsCardForPreview() {
    return drpRequest.get('/partner/channel/getPromoteGoodsCardForPreview')
}
// 分销小站分类
/**
 * 获取展架分类列表
 */
export function getMallCategory(): API.Res<GoUserCategoryVo[]> {
    return goodsRequest.get('/mall/userCategory/listWithNumber')
}

// 分销小站供销商品列表
/**
 * 分销商城供销商品列表
 */
export function queryMallGoodsList(data: DistributionGoodsListQueryVo1): API.Res<DistributionSpuVo[]> {
    return goodsRequest.post('/mall/goods/distributionList', { data })
}

// 获取商品的展架分类
/**
 * 获取商品的展架分类列表
 */
export function getSpuUserCategoryList(data: string[]): API.Res<SpuUserCategoryVo[]> {
    return goodsRequest.post('/mall/goods/spuUserCategoryList', { data })
}

// 更新商品展架分类
/**
 * 更新商品展架分类
 */
export function updateUserCategory(data: UpdateSpuCategoryParam): API.Res<boolean> {
    return goodsRequest.post('/mall/goods/updateUserCategory', { data })
}

// 分销海报，获取公开商品列表
/**
 * 分销海报，获取公开商品列表
 */
export function getMallGoodsOpenSpuList(params: OpenSpuListUsingGetParams): API.Res<PostSpuVo[]> {
    return goodsRequest.get('/mall/goods/openSpuList', { params })
}

// 分销海报，获取公开商品列表(V2版本支持类目、自选商品等数据参数)
/**
 * 分销海报，获取公开商品列表
 */
export function getMallGoodsOpenSpuListV2(data: PostSpuQueryVo): API.Res<PostSpuVo[]> {
    return goodsRequest.post('/mall/goods/openSpuListV2', { data })
}

// 供应商推广分享的商品数量统计
/**
 * 供应商推广分享的商品数量统计
 */
export function getMallGoodsOpenSpuListCount(data: QueryInviteSpuCountVo): API.Res<InviteDisSpuCountVo> {
    return goodsRequest.post('/mall/goods/invite/count', { data })
}

// 分销海报创建自选商品参数
/**
 * 创建参数
 */
export function createMallGoodsOpenSpuParam(data: CreateParamVo): API.Res<string> {
    return goodsRequest.post('/mall/goods/invite/createParam', { data })
}

// 展架分类下的可分销商品数量统计，已分类&未分类
/**
 * 展架分类下的可分销商品数量统计，已分类&未分类
 */
export function getDisGoodsStatistics(): API.Res<DisGoodsStatisticsVo> {
    return goodsRequest.get('/mall/goods/disGoodsStatistics')
}

// 查询访客信息列表
/**
 * 查询访客信息列表
 */
export function queryVisitorInfoV2(params: QueryVisitorInfoUsingGetParams): API.Res<VisitorInfoVo[]> {
    return drpRequest.get('/visitorInfo/queryVisitorInfo', { params })
}

// 查询访客统计数量
/**
 * 查询访客统计
 */
export function queryVisitorCount(params: QueryVisitorCountUsingGetParams): API.Res<VisitorCountVo> {
    return drpRequest.get('/visitorInfo/queryVisitorCount', { params })
}

// 查询访客统计 获取全部主营平台和主营类目
/**
 * 获取全部主营平台和主营类目
 */
export function queryAllPlatformAndCategory(): API.Res<PlatformAndCategoryVo> {
    return drpRequest.get('/visitorInfo/getAllPlatformAndCategory')
}

// 查询访客统计 最后更新时间
/**
 * 获取最后更新时间
 */
export function queryLastUpdateDate(): API.Res<string> {
    return drpRequest.get('/visitorInfo/getLastUpdateDate')
}

// 获取分销小站已选择的商品数据
/**
 * 获取分销商城已选择的商品数据
 */
export function inviteSelectedSpuList(data: QueryMallSelectedSpuVo): API.Res<GoodsMallSelectedSpuVo[]> {
    return goodsRequest.post('/mall/goods/invite/selectedSpuList', { data })
}

// 获取访客趋势
/**
 * 获取访客趋势
 */
export function getVisitorTrend(params: GetVisitorTrendUsingGet1Params): API.Res<VisitorTrendVo[]> {
    return drpRequest.get('/visitorInfo/getVisitorTrend', { params })
}

// 获取是否有分销商品
/**
 * 分销商城供销商品列表是否有数据
 */
export function queryHasDistributionGoodsData(): API.Res<boolean> {
    return goodsRequest.post('/mall/goods/hasDistributionGoodsData')
}

// 获取是否有平台资料商品
/**
 * 商家是否有商品数据
 */
export function queryHasOwnGoodsData(): API.Res<boolean> {
    return goodsRequest.get('/mall/goods/hasGoodsData')
}

// 查询分销自动推送设置
export function queryAutoExtendSettings(params) {
    return goodsBasicRequest.get('/supplierConfig/queryAutoPromoteNewGoods', {
        params,
    })
}

// 保存分销自动推送设置
export function saveAutoExtendSettings(data) {
    return goodsBasicRequest.post('/supplierConfig/modifyAutoPromoteNewGoods', {
        data,
    })
}
// 修改自动下架供应商不可分销(已下架)的商品
/**
 * 修改自动下架供应商不可分销(已下架)的商品
 */
export function saveAutoRemoveGoods(data: GoSupplierConfig): API.Res<AutoForSaleResultVo> {
    return goodsRequest.post('/supplierConfig/modifyAutoForSaleDistributorGoods', { data })
}

// 查询自动下架供应商不可分销(已下架)的商品
export function queryAutoRemoveGoods(data) {
    return goodsBasicRequest.get('/supplierConfig/queryAutoForSaleDistributorGoods', {
        data,
    })
}

// 查询供应商已下架的商品数量
/**
 * 查询供应商已下架的商品数量
 */
export function queryRemovedGoods(): API.Res<SupplierForSaleNumVo> {
    return goodsRequest.get('/mall/goods/querySupplierForSaleNum')
}

// 自动推送新商品[20231109后端接口升级成autoPromoteNewItemV2]
/**
 * 自动推广新品
 */
export function autoPromoteNewItem(): API.Res<PromoteAutoResult> {
    return goodsRequest.post('/goGoodsPromote/autoPromoteNewItemV2')
}

// 批量下架供应商已下架的商品
/**
 * 分销小站移除供应商已下架的代发商品
 */
export function removeSupplierForSaleGoodsV3(data: MallItemRemoveParam): API.Res<MallItemRemoveResult> {
    return goodsRequest.post('/mallItemRemove/removeSupplierForSaleGoodsV3', { data })
}

// 获取进度信息
/**
 * 获取单个商品信息
 */
export function getOnlineRecordInfo(params: QueryTaskUsingGet3Params): API.Res<RedisProgressInfo> {
    return goodsRequest.get('/online/goods/queryTask', { params })
}

// 我的分销小站列表 简化接口
/**
 * 品牌小站查询商品列表
 */
export function querySimpleGoods(data: BuyerSupplierGoodsQuery2): API.Res<BrandMallGoodsVo[]> {
    return goodsRequest.post('/mall/goods/querySimpleGoods', { data })
}

// 获取分销小站引导
/**
 * 获取分销小站引导
 */
export function getSiteGuideConfig(): API.Res<object> {
    return drpRequest.get('/config/getSiteGuide')
}

// 已分享小站好货
/**
 * 已分享小站好货
 */
export function updateSiteGuideShareConfig(): API.Res<object> {
    return drpRequest.post('/config/updateShare')
}

// 已预览分享效果
/**
 * 已预览分享效果
 */
export function updateSiteGuidePreviewConfig(): API.Res<object> {
    return drpRequest.post('/config/updatePreview')
}

// 获取分销小站公告 (open)
/**
 * 获取分销小站公告
 */
export function getSiteNoticeOpen(params: GetSiteNoticeUsingGet1Params): API.Res<string> {
    return openDrpRequest.get('/open/config/getSiteNotice', { params })
}

// 修改分销小站公告
/**
 * 修改分销小站公告
 */
export function updateSiteNotice(data: CoConfig): API.Res<object> {
    return drpRequest.post('/config/updateSiteNotice', { data })
}

// 设置小站所有的私有商品为公开商品
/**
 * 设置小站所有的私有商品为公开商品
 */
export function allPrivateStatusToPublic(): API.Res<string> {
    return goodsRequest.get('/mall/goods/allPrivateStatusToPublic')
}

// 查询无主图商品数量与未公开商品数量
/**
 * 查询无主图商品数量与未公开商品数量
 */
export function queryMainImgIsNullAndPrivateGoodsNum(): API.Res<MainImgIsNullAndPrivateGoodsNum> {
    return goodsRequest.get('/mall/goods/queryMainImgIsNullAndPrivateGoodsNum')
}

// 查询重复商品数量
/**
 * 查询重复商品数量
 */
export function queryRepeatNum(): API.Res<RepeatGoodsNum> {
    return goodsRequest.get('/mall/goods/queryRepeatNum')
}

// 分销小站移除无库存商品
/**
 * 分销小站移除无库存商品
 */
export function removeNoneStockV2(data: MallItemRemoveParam): API.Res<MallItemRemoveResult> {
    return goodsRequest.post('/mallItemRemove/removeNoneStockV2', { data })
}

// 获取商家下的店铺总数
/**
 * 获取商家下的店铺总数
 */
export function queryShopCount(params: ShopCountUsingGetParams): API.Res<ShopStatisticsVO[]> {
    return companyRequest.get('/sales/gylErpShopInfo/shopCount', { params })
}

// 查找绑定线下供应商
/**
 * 查找绑定线下供应商
 */
export function queryBindOfflineSupplier(
    params: FindBindOfflineSupplierUsingGetParams,
): API.Res<FindBindOfflineSupplierResult> {
    return towerDrpRequest.get('/drpPartner/findBindOfflineSupplier', { params })
}

// 分销客户中心推广商品
/**
 * 分销客户中心推广商品
 */
export function addPromoteGoodsByDrpCenter(data: SupplierPromoteGoodsParam): API.Res<SupplierPromoteChannelResult> {
    return goodsRequest.post('/supplierActivity/addPromoteGoodsByDrpCenter', { data })
}

// 供应商推广商品
/**
 * 供应商推广商品
 */
export function addPromoteGoodsV2(data: SupplierPromoteGoodsParam): API.Res<SupplierPromoteChannelResult> {
    return goodsRequest.post('/supplierActivity/addPromoteGoodsV2', { data })
}

// 根据商品ID查询确认推广参数
/**
 * 根据商品ID查询确认推广参数
 */
export function queryPromoteGoodsList(data: PromoteGoodsItemParam): API.Res<PromoteGoodsItemResult[]> {
    return goodsRequest.post('/supplierActivity/promoteGoodsList', { data })
}

// 分销海报，获取商品列表
/**
 * 分销海报，获取商品列表
 */
export function postSpuList(data: PostSpuQueryVo): API.Res<PostSpuVo[]> {
    return goodsRequest.post('/mall/goods/postSpuList', { data })
}

// 查询今日推广分销商数量信息
/**
 * 查询今日推广分销商数量信息
 */
export function queryToDayPromoteChannelNum(data: string[]): API.Res<SupplierPromoteChannelResult> {
    return goodsRequest.post('/supplierActivity/queryToDayPromoteChannelNum', { data })
}

// 查询商家能力
/**
 * 查询商家能力
 */
export function getSupplierCapacity(): API.Res<SupplierCapacityVo> {
    return drpRequest.get('/supplierInfo/getSupplierCapacity')
}

// 合伙人查询合作供应商能力
/**
 * 合伙人查询合作供应商能力
 */
export function partnerQuerySupplierCapacity(
    params: PartnerQuerySupplierCapacityUsingGetParams,
): API.Res<SupplierCapacityVo> {
    return drpRequest.get('/supplierInfo/partnerQuerySupplierCapacity', { params })
}
